class MobileProductForm extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setupOverlay();
    this.bindEvents();
  }

  setupOverlay() {
    if (!document.querySelector('.mobile-form-overlay')) {
      const overlay = document.createElement('div');
      overlay.className = 'mobile-form-overlay';
      document.body.appendChild(overlay);
    }
    this.overlay = document.querySelector('.mobile-form-overlay');
  }

  bindEvents() {
    const closeBtn = this.querySelector('.mobile-form-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeForm());
    }

    this.overlay.addEventListener('click', () => this.closeForm());

    // Variant selection events
    const variantInputs = this.querySelectorAll('input[type="radio"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => this.handleVariantChange(input));
    });

    // Quick add button events
    const quickAddButtons = document.querySelectorAll('.mobile-quick-add-button');
    quickAddButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleQuickAdd(e, button));
    });
  }

  closeForm() {
    const form = this.querySelector('.mobile-product-form');
    if (form) {
      form.classList.remove('is-active');
      this.overlay.classList.remove('is-active');
    }
  }

  handleVariantChange(input) {
    if (input.checked) {
      this.addToCart(input.value);
    }
  }

  handleQuickAdd(e, button) {
    e.preventDefault();
    const form = button.closest('.mobile-quick-add').querySelector('.mobile-product-form');
    if (form) {
      form.classList.add('is-active');
      this.overlay.classList.add('is-active');
    }
  }

  addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      this.closeForm();
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
}

customElements.define('mobile-product-form', MobileProductForm); 